import * as d3 from 'd3';
import { ZOOM_RANGE } from '../render-utils/constants';

let zoomElm;

export const setZoom: (canvas: HTMLCanvasElement) => void = (canvas) => {
  zoomElm = d3.select(canvas);

  const zoom = d3.zoom();
  zoom.scaleExtent(ZOOM_RANGE);

  return zoom;
};

export const getZoomElm: () => any = () => zoomElm;
